import { createContext, useState, ReactNode } from 'react';

interface GlobalLoadingContextType {
  isInitializing: boolean;
  setIsInitializing: (value: boolean) => void;
}

const GlobalLoadingContext = createContext<GlobalLoadingContextType>({
  isInitializing: false,
  setIsInitializing: () => {},
});

// TEMPORARILY DISABLED - No loading skeleton for UI testing
export function GlobalLoadingProvider({ children }: { children: ReactNode }) {
  const [isInitializing, setIsInitializing] = useState(false);

  return (
    <GlobalLoadingContext.Provider value={{ isInitializing, setIsInitializing }}>
      {children}
    </GlobalLoadingContext.Provider>
  );
}
